import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import {BalanceApi, PayerApi, OrderApi, CartApi} from "./v1_employer_accounting";

const BASE_URL = '/';

const axiosInstance: AxiosInstance = axios.create({
    baseURL: BASE_URL,
});

export const employerAccountingApiV1 = Object.freeze({
    balance: new BalanceApi(undefined, undefined, axiosInstance),
    payer: new PayerApi(undefined, undefined, axiosInstance),
    order: new OrderApi(undefined, undefined, axiosInstance),
    cart: new CartApi(undefined, undefined, axiosInstance),
})
